import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, InProgressIcon } from 'edenred-ui';
import { useFormContext } from 'react-hook-form';
import styled, { useTheme } from 'styled-components';

import { SingleClickButton } from '@epi-components/SingleClickButton';
import { FormFields } from '@epi-forms/helpers';
import { IExternalPayment } from '@epi-models/forms/PaymentMethod';

const HoverShadowBox = styled(Box)`
  &:hover {
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.13);
  }
`;

export const ExternalPaymentRadio = ({
  isLoading,
  methods,
  isError,
  disabled,
  isProcessing
}: IExternalPayment) => {
  const { t } = useTranslation();
  const { gray10, primaryFrontColor, gray50 } = useTheme();
  const { setValue, watch } = useFormContext();

  const methodCode = watch(FormFields.PaymentMethodCode);

  return (
    <>
      <Box pb={2} color={gray50}>
        {t('forms.payment_method.choose_bank')}
      </Box>
      <div className="ExternalPayment external-payment">
        {isLoading && !isError && <InProgressIcon />}{' '}
        {isLoading && !isError && t('application.loading')}
        {!isLoading &&
          !isError &&
          methods?.map(item => (
            <HoverShadowBox
              width={144}
              display="flex"
              alignItems="center"
              justifyContent="center"
              key={item.code}
              border={1}
              mr={4}
              mb={2}
              borderColor={
                methodCode === item.code ? primaryFrontColor : gray10
              }
            >
              <SingleClickButton
                id="create-external-payment-btn"
                disabled={disabled || isProcessing}
                className="external-payment"
                type="button"
                onClick={e => {
                  e.preventDefault();

                  if (!isProcessing) {
                    setValue(FormFields.PaymentMethodCode, item.code);
                  }
                }}
              >
                <img
                  className="payment-type"
                  alt={item.name}
                  height={'64px'}
                  width={'auto'}
                  src={item.image_url}
                />
              </SingleClickButton>
            </HoverShadowBox>
          ))}
      </div>
    </>
  );
};
